import $ from "jquery";

export class MuraflexModule {
	slideItemNumber: NodeList = document.querySelectorAll('[data-mflex-current]');
	slideTotalNumber: NodeList = document.querySelectorAll('[data-mflex-count]');

	constructor(event, slick, statement, currentSlide, nextSlide) {

		statement === "init"
			? this.handleInit(slick)
			: (statement === "beforeChange"
				? this.handleBeforeChange(slick, currentSlide, nextSlide)
				: (statement === "afterChange"
					? this.handleAfterChange(slick)
					: this.Muraflex()));
	}

	private Muraflex = () => {
		setTimeout(function () {
			$('.mflex').css('opacity', '1');
		}, 900)
	}

	private handleInit(slick) {
		const slidesCount: number = slick.$slides.length;
		const CurrentSlide = $('#mflex-slider').find('.slick-current').index();
		slick.$slides.removeClass('prevSlide').removeClass('nextSlide');

		console.log(slidesCount);

		// Adds total slide count to all slides
		for (let i = 0; i < this.slideTotalNumber.length; i++) {
			const element = <HTMLElement>this.slideTotalNumber[i];
			if (slidesCount >= 10) {
				element.innerHTML = `/${slidesCount}`;
			} else {
				element.innerHTML = `/0${slidesCount}`;
			}

		}

		// Adds current slide index to slideItemNumber
		for (let i = 0; i < slidesCount; i++) {
			if (i === CurrentSlide) {
				for (let i = 0; i < this.slideItemNumber.length; i++) {
					const element = <HTMLElement>this.slideItemNumber[i];
					if (slidesCount >= 10) {
						element.innerHTML = `${i}`
					} else {
						element.innerHTML = `0${i}`
					}
				}

			}
		}

	}

	private handleAfterChange(slick) {
		for (let i = 0; i < slick.$slides.length; i++) {

			const $slide = $(slick.$slides[i]);

			if ($slide.hasClass("forwards") && $slide.hasClass("slick-current")) {
				$slide.removeClass("forwards");
				$slide.addClass("forwards--after");
			} else if ($slide.hasClass("backwards") && $slide.hasClass("slick-current")) {
				$slide.removeClass("backwards");
				$slide.addClass("backwards--after");
			} else {
				$slide.removeClass("backwards");
				$slide.removeClass("forwards");
			}
		}
	}

	private handleBeforeChange(slick, currentSlide, nextSlide) {
		$(".slick-slide").removeClass("backwards--after");
		$(".slick-slide").removeClass("forwards--after");

		let movingForwards: boolean = false;

		// Set moving forwards to true, if  moving from last to first of slick slideshow
		if (currentSlide === slick.$slides.length - 1 && nextSlide === 0) {
			movingForwards = true; // Set moving forwards to false, if moving from first to last
		} else if (currentSlide === 0 && nextSlide === slick.$slides.length - 1) {
			movingForwards = false;
		} else if (currentSlide < nextSlide) { // Set movingforwards to true - if next slide index is larger than the current
			movingForwards = true;
		} else if (nextSlide < currentSlide) { // Set moving forwards to false, if next slide is smaller than the current.
			movingForwards = false;
		}

		if (movingForwards) {
			$(".slick-slide").addClass("forwards");
		} else if (movingForwards === false) {
			$(".slick-slide").addClass("backwards");
		}
	}

}
